import { render } from "./MainLogin.vue?vue&type=template&id=5a648990&scoped=true"
import script from "./MainLogin.vue?vue&type=script&lang=js"
export * from "./MainLogin.vue?vue&type=script&lang=js"

import "./MainLogin.vue?vue&type=style&index=0&id=5a648990&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a648990"]])

export default __exports__